const REACT_APP_API_URL = 'https://p95dgw23u7.execute-api.us-west-1.amazonaws.com';
const REACT_APP_BUCKET = 'dev-newcenturyapi-storage-uploadsbucketc4b27cc7-1eu86kdydm8fx';
const REACT_APP_IDENTITY_POOL_ID = 'us-west-1:2ddad4c2-e194-44be-9c6a-ad1ea0e65630';
const REACT_APP_USER_POOL_CLIENT_ID = 'u39j126liblihop5c61jc7n1b';
const REACT_APP_USER_POOL_ID = 'us-west-1_39v772a2n';
const REACT_APP_REGION = 'us-west-1';

const config = {
  DEV_STRIPE_KEY: 'pk_test_BPK2Pf40xNOHVnWZ2YTqrNg3',
  PROD_STRIPE_KEY: 'pk_live_b2mymYT46HUTmIwvvIqSvXip',
  MAX_ATTACHMENT_SIZE: 5000000,
  // Backend config
  s3: {
    REGION: REACT_APP_REGION,
    BUCKET: REACT_APP_BUCKET,
  },
  apiGateway: {
    REGION: REACT_APP_REGION,
    URL: REACT_APP_API_URL,
  },
  cognito: {
    REGION: REACT_APP_REGION,
    USER_POOL_ID: REACT_APP_USER_POOL_ID,
    APP_CLIENT_ID: REACT_APP_USER_POOL_CLIENT_ID,
    IDENTITY_POOL_ID: REACT_APP_IDENTITY_POOL_ID,
  },
  // My project specific configs
  isDev: false,
  devDynamooseClaudia: 'http://localhost:3000/',
  prodDynamooseClaudia: 'https://bnbxyypqb2.execute-api.us-west-2.amazonaws.com/latest/',
  // prodDynamooseClaudia: 'https://wer01yptoj.execute-api.us-west-2.amazonaws.com/latest/',
};

// The error we are getting is an error on the dynamoose/claudia side
// We need to fix the cors error on the dynamoose/claudia endpoints

// prod: 'https://p95dgw23u7.execute-api.us-west-1.amazonaws.com/latest/', // 
// prod: 'https://wer01yptoj.execute-api.us-west-2.amazonaws.com/latest/', // old dynamoose/claudia


config.serverUrl = config.isDev ? config.devDynamooseClaudia : config.prodDynamooseClaudia;
config.STRIPE_KEY = config.isDev ? config.DEV_STRIPE_KEY : config.PROD_STRIPE_KEY;

export default config;
